import { apiClient } from './client'
import type { User, UserRole } from './types'

export interface CreateUserPayload {
  display_name: string
  email: string
  password: string
  role: UserRole
}

export interface UpdateUserPayload {
  display_name?: string
  email?: string
  password?: string
  role?: UserRole
  active?: boolean
}

export async function listUsers(): Promise<User[]> {
  const { data } = await apiClient.get<User[]>('/users')

  return data
}

export async function listAssignableRoles(): Promise<UserRole[]> {
  const { data } = await apiClient.get<{ roles: UserRole[] }>('/users/roles')

  return data.roles
}

export async function createUser(payload: CreateUserPayload): Promise<User> {
  const { data } = await apiClient.post<User>('/auth/register', payload)

  return data
}

export async function updateUser(id: number, payload: UpdateUserPayload): Promise<User> {
  const { data } = await apiClient.patch<User>(`/users/${id}`, payload)

  return data
}

export async function deactivateUser(id: number): Promise<void> {
  await apiClient.delete(`/users/${id}`)
}

export async function reactivateUser(id: number): Promise<User> {
  return updateUser(id, { active: true })
}
